import api from '../api'
export default {
  namespaced: true,
  state: {
    produceList: [],
    produceTotal: '',
    produceDetail: ''
  },
  mutations: {
    GET_PRODUCE_LIST (state, data = {}) {
      state.produceList = data.records || []
      state.produceTotal = data.total
    },
    GET_PRODUCE_DETAIL (state, data) {
      state.produceDetail = data
    }
  },
  actions: {
    GET_PRODUCE_LIST ({ commit, dispatch }, config) {
      return api.produceList(config).then((res) => {
        commit('GET_PRODUCE_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    GET_PRODUCE_DETAIL ({ commit, dispatch }, config) {
      return api.produceDetail(config).then((res) => {
        commit('GET_PRODUCE_DETAIL', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_PRODUCE ({ commit, dispatch }, params) {
      return api.deleteproduce({
        params: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    ADD_PRODUCE ({ commit, dispatch }, config) {
      return api.addproduce(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_PRODUCE ({ commit, dispatch }, config) {
      return api.updateproduce(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/produceManage/store/index.js